export default () => {
  const $bsAccordions = $('.bs-accordion__container');

  if ($bsAccordions.length) {
    $bsAccordions.each((i, e) => {
      const $accordion = $(e);
      const id = $accordion.attr('id');

      if (id) {
        $accordion.find('.bs-accordion__item .collapse').each((i, item) => {
          $(item)
            .attr('data-parent', `#${id}`);
        });
      }
    });
  }
};
